import { useCallback } from 'react';
import {
  getProductAttribute,
  getMultipleProductAttributes,
  ProductAttribute,
  ProductAttributeCode,
  ProductAttributeCollection,
} from 'src/models/pim/attributes';

export const useProductAttributes = (attributes: ProductAttribute[]) => {
  return {
    getProductAttribute: useCallback(
      <T extends ProductAttributeCode | ProductAttributeCollection>(
        codeOrCollection: T,
        attrs: ProductAttribute[] = attributes,
      ) => getProductAttribute(attrs, codeOrCollection),
      [attributes],
    ),

    getMultipleProductAttributes: useCallback(
      <T extends ProductAttributeCode | ProductAttributeCollection>(
        codeOrCollection: T,
        attrs: ProductAttribute[] = attributes,
      ) => getMultipleProductAttributes(attrs, codeOrCollection),
      [attributes],
    ),
  };
};
